var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2400 2400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "{200} ",
    strokeLinecap: "round",
    stroke: "currentColor",
    fill: "none",
    color: "black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1200 600L1200 100"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.5}",
    d: "M1200 2300L1200 1800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.917}",
    d: "M900 680.4L650 247.4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.417}",
    d: "M1750 2152.6L1500 1719.6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.833}",
    d: "M680.4 900L247.4 650"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.333}",
    d: "M2152.6 1750L1719.6 1500"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.75}",
    d: "M600 1200L100 1200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.25}",
    d: "M2300 1200L1800 1200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.667}",
    d: "M680.4 1500L247.4 1750"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.167}",
    d: "M2152.6 650L1719.6 900"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.583}",
    d: "M900 1719.6L650 2152.6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "{0.083}",
    d: "M1750 247.4L1500 680.4"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    keyTimes: "0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667",
    values: "0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199",
    dur: "0.83333s",
    begin: "0s",
    repeatCount: "indefinite",
    calcMode: "discrete"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.67318f436307c514229cdf40ad77e458.svg";
export { ForwardRef as ReactComponent };